import store from '../store'
import moment from 'moment'
import { merge } from 'lodash'
import PGSHelper from '../helpers/PGSHelper.js';

export default class Tarifario {
    static typeSearch      = "local" //online || local

    constructor(data = null) {
        this.Nombre             = (data?.Nombre)?data.Nombre:"";
        this.Accesos             = (data?.Apellidos)?data.Accesos:"";
        this.Activo             = (data?.Activo)?data.Activo:"";
        this.Tenant             = (data?.Tenant)?data.Tenant:store.getters.getFirebaseApp.tenant;
        this.Id                 = (data?.Id)?data.Id:null;
    }

    static getPropertyModel(){
        return this;
    }



}